import { down } from 'styled-breakpoints';
import styled from 'styled-components';

import bg from 'assets/images/cover-mpr-404.png';

export const NotFoundWrapper = styled.div`
    max-width: 100%;
    height: 100%;

    background-image: url(${bg});
    background-size: cover;
    background-position: top center;
    margin: 0px 32px 32px;
    border-radius: 50px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;

    ${down('sm')} {
        margin: 0px 0px -16px;
    }

    .bigFont {
        font-weight: 700;
        line-height: 449px;
        font-size: 371px;

        ${down('xxl')} {
            line-height: 349px;
            font-size: 271px;
        }
        ${down('lg')} {
            line-height: 300px;
            font-size: 271px;
        }
        ${down('md')} {
            line-height: 249px;
            font-size: 171px;
        }
        ${down('sm')} {
            line-height: 79px;
            font-size: 51px;
        }
    }

    .smallFont {
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 20px;

        ${down('xxl')} {
            font-size: 26px;
            line-height: 34px;
        }
        ${down('lg')} {
            font-size: 26px;
            line-height: 34px;
        }
        ${down('md')} {
            font-size: 24px;
            line-height: 16x;
        }
        ${down('sm')} {
            font-size: 14px;
            line-height: 8px;
        }
    }

    button {
        ${down('lg')} {
            margin-top: 12px;
            font-size: 12px;
            padding: 12px 18px;
        }

        ${down('md')} {
        }

        ${down('sm')} {
        }
    }
`;
